module.exports = __webpack_public_path__ + "img/hand-point-down.c5ead005.svg";